import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledSearchContainer = styled.div`
	margin-top: 20px;
`;

const StyledControlsContainer = styled.div`
	position: fixed;
	left: 0;
	bottom: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 80px;
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 491px;

	${Text} {
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledControlsContainer,
	StyledEmptyContainer,
	StyledListWrapper,
	StyledSearchContainer,
};
